import { Alerts } from "../../../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../../../contexts/RPCContext.js";
import { FormikSelectPriority } from "../../../../../../components/Priority/FormikSelectPriority.js";
import { EventSelectLocation } from "../../../../components/EventSelectLocation.js";
import { EventDateTimeField } from "../../../../components/EventDateTimeField.js";
import { FormikSelectActivityTypeTag } from "../../../../../Tags/shared/FormikSelectActivityTypeTag.js";
import { useMemo } from "react";
import { FormLayout } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Events/shared/EventInteractive/EventDetails/components/EditEventDetailsForm.tsx
var ValidationSchema = Yup.object().shape({
	activityTypeTags: Yup.array(Yup.object()).nullable(),
	date: Yup.string().required("Date/Time is required"),
	locationId: Yup.string().required("Location is required"),
	priority: Yup.number().required("Priority is required")
});
var EditEventDetailsForm = ({ event, onCancel, onComplete }) => {
	const { rpcService } = useRPCContext();
	const save = async (values) => {
		try {
			await rpcService.Events.UpdateEvent.v2.call({ event: values });
			Alerts.success("Event updated");
			onComplete();
		} catch (err) {
			console.log("Events.UpdateEvent.v1.call() err", err);
			Alerts.error("There was a problem updating the Event", err.message);
		}
	};
	const initialValues = useMemo(() => event, []);
	return /* @__PURE__ */ jsx(Formik, {
		initialValues,
		onSubmit: save,
		enableReinitialize: true,
		validationSchema: ValidationSchema,
		validateOnChange: true,
		children: ({ isSubmitting, submitForm }) => /* @__PURE__ */ jsxs(FormLayout, { children: [
			/* @__PURE__ */ jsx(EventSelectLocation, {}),
			/* @__PURE__ */ jsx(EventDateTimeField, {}),
			/* @__PURE__ */ jsx(FormikSelectActivityTypeTag, {
				label: "Activity Types",
				multi: true,
				name: "activityTypeTags"
			}),
			/* @__PURE__ */ jsx(FormikSelectPriority, {
				label: "Priority",
				name: "priority"
			}),
			/* @__PURE__ */ jsx(FormLayout.Controls, {
				disabled: isSubmitting,
				onCancel,
				onSave: submitForm,
				submitLabel: "Save"
			})
		] })
	});
};
//#endregion
export { EditEventDetailsForm };

//# sourceMappingURL=EditEventDetailsForm.js.map